let n;
const o = (i) => {
  n = i;
};
export {
  n as config,
  o as initConfig
};
